export default "__VITE_ASSET__e7EM1jPy__"